
import React from 'react';
import { ChildAlertProps } from '../BaseAlert.component';
import { useTranslation } from 'react-i18next';
import WarningAlertComponent from '../WarningAlert.component';
import styled from 'styled-components';

const StyledMessageWrapper = styled.div`
  white-space: pre;
`;

const HrWidgetJobRemoveAlert = ({ handleConfirm }: ChildAlertProps) => {
  const { t } = useTranslation();
  return (
    <WarningAlertComponent onClose={handleConfirm}>
      <StyledMessageWrapper>
        {t('Job will be removed')}
        <br />
        {t('Are you sure you want to delete job?')}
      </StyledMessageWrapper>

    </WarningAlertComponent>
  )
}

export default HrWidgetJobRemoveAlert;